var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "step-counter" },
    _vm._l(_vm.totalSteps, function(num) {
      return _c("span", {
        staticClass: "dot",
        class: { active: num === _vm.currentStep }
      })
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7ec3282c", { render: render, staticRenderFns: staticRenderFns })
  }
}